import React, { useEffect, useRef, useState } from "react";

import translations from "../quoteForm/quote-form-translations";
import config from "../../config";

const AutoComplete = (props) => {
  const [loaded, setLoaded] = useState(false);

  // setAddress mutates the quote object of the render it was created in, so the
  // Places listeners must always call the latest one: keep it in a ref instead of
  // rebuilding the Autocomplete instances on every render.
  const setAddressRef = useRef(props.setAddress);
  setAddressRef.current = props.setAddress;

  useEffect(() => {
    if (window.google) return;
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src =
      "https://maps.googleapis.com/maps/api/js?callback=Function.prototype&libraries=places&key=" +
      config["google-map-key"];
    script.addEventListener("load", ()=>setLoaded(true));
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if(!loaded && !window.google) return;
    const google = window.google;

    const geolocation = {
      lat: 45.7234181,
      lng: 5.088776800000005,
    };

    const circle = new google.maps.Circle({
      center: geolocation,
      radius: 100,
    });

    const options = {
      componentRestrictions: { country: ["fr", "ch"] },
    };

    let addressDepart = document.getElementById("address-depart");
    let autocomplete_from = new google.maps.places.Autocomplete(
      addressDepart,
      options
    );
    autocomplete_from.addListener("place_changed", function () {
        setAddressRef.current(autocomplete_from,'depart');
    });
    addressDepart.addEventListener("change", function () {
      addressDepart.value = null;
    });
    autocomplete_from.setBounds(circle.getBounds());

    let addressarrive = document.getElementById("address-arrive");
    let autocomplete_to = new google.maps.places.Autocomplete(
      addressarrive,
      options
    );
    autocomplete_to.addListener("place_changed", function () {
        setAddressRef.current(autocomplete_to,'arrive');
    });
    addressarrive.addEventListener("change", function () {
      addressarrive.value = null;
    });
    autocomplete_to.setBounds(circle.getBounds());
  }, [loaded]);

  return (
    <div className="addr-card">
      <div className="addr-rail addr-rail-from" aria-hidden="true">
        <span className="addr-spacer"></span>
        <span className="addr-dot addr-dot-from"></span>
        <span className="addr-line"></span>
      </div>
      <div className="addr-field addr-field-from">
        <label htmlFor="address-depart">
          {translations[props.lang].startPlace.label}
        </label>
        <input
          type="text"
          className="pac-target-input"
          id="address-depart"
          name="address_depart"
          placeholder={translations[props.lang].startPlace.placeholder}
          required
          autoComplete="off"
        />
      </div>
      <div className="addr-rail addr-rail-to" aria-hidden="true">
        <span className="addr-line"></span>
        <span className="addr-dot addr-dot-to"></span>
        <span className="addr-spacer"></span>
      </div>
      <div className="addr-field addr-field-to">
        <label htmlFor="address-arrive">
          {translations[props.lang].toPlace.label}
        </label>
        <input
          type="text"
          className="pac-target-input"
          id="address-arrive"
          name="address_arrive"
          placeholder={translations[props.lang].toPlace.placeholder}
          required
          autoComplete="off"
        />
      </div>
      <div className="addr-swap-cell">
        <button
          type="button"
          className="addr-swap"
          aria-label={translations[props.lang].swap}
          onClick={props.onSwap}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M8 20V5"></path>
            <path d="M4.5 8.5 8 5l3.5 3.5"></path>
            <path d="M16 4v15"></path>
            <path d="M12.5 15.5 16 19l3.5-3.5"></path>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AutoComplete;
